module.exports = {
  context: {
    masthead: '@masthead',
    hero: {
      type: 'image-icon',
      heading: {
        text: 'Our Work',
        tag: 'h1',
        class: 'heading-4'
      },
      icon: {
        url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/icon-veterans.svg?mtime=20210708142244&focal=none',
        alt: 'veterans'
      },
      bannerImage: {
        src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/veterans.jpg?mtime=20210628092505&focal=none',
        alt: 'Catalysts'
      },
      breadcrumbs: '@breadcrumb'
    },
    sidebar: {
      subNavigation: {
        nodes: [
          {
            id: '64',
            title: 'Veterans Community Services',
            url: 'http://adjoin.nitro/catalyst-community-services',
            children: [
              {
                id: '175',
                title: 'Live',
                url: 'http://adjoin.nitro/catalyst-community-services/live',
                children: [
                  {
                    id: '180',
                    title: 'Subpage',
                    url: 'http://adjoin.nitro/catalyst-community-services/subpage'
                  },
                  {
                    id: '181',
                    title: 'Subpage',
                    url: 'http://adjoin.nitro/catalyst-community-services/subpage'
                  },
                  {
                    id: '182',
                    title: 'Subpage',
                    url: 'http://adjoin.nitro/catalyst-community-services/subpage'
                  }
                ]
              },
              {
                id: '176',
                title: 'Work',
                url: 'http://adjoin.nitro/catalyst-community-services/work'
              },
              {
                id: '177',
                title: 'Learn',
                url: 'http://adjoin.nitro/catalyst-community-services/learn'
              },
              {
                id: '178',
                title: 'Play',
                url: 'http://adjoin.nitro/catalyst-community-services/play'
              }
            ]
          }
        ]
      },
      ulClass: 'subnav-menu clicky-menu',
      liClass: 'navbar-item',
      activeClass: 'current'
    },
    mainContent: {
      heading: 'Heading',
      text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
      iconGroup: {
        class: 'icon-list',
        cards: [
          {
            icon: {
              svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            },
            heading: {
              text: 'Challenge',
              tag: 'h3',
              class: 'heading-3'
            },
            shortDescription: {
              text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
            }
          },
          {
            icon: {
              svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            },
            heading: {
              text: 'Solution',
              tag: 'h3',
              class: 'heading-3'
            },
            shortDescription: {
              text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
            }
          },
          {
            icon: {
              svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            },
            heading: {
              text: 'Impact',
              tag: 'h3',
              class: 'heading-3'
            },
            shortDescription: {
              text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
            }
          }
        ]
      }
    },
    footer: '@footer'
  }
}
